import { AloftPrice, isDefined, isUndefined } from '@aloft/toolkit-shared';

import { createPriceSelector } from '../utils/createPriceSelector.ts';
import { selectCarportCost, selectZipOnlyCarportCost } from './selectCarportCost.ts';
import { selectGarageCost, selectZipOnlyGarageCost } from './selectGarageCost.ts';

const calculateGarageCarportCost = (
  garageCost: AloftPrice | undefined,
  carportCost: AloftPrice | undefined,
) => {
  if (isUndefined(garageCost) && isUndefined(carportCost)) return undefined;

  const garage = isDefined(garageCost) ? garageCost : AloftPrice.zero;
  const carport = isDefined(carportCost) ? carportCost : AloftPrice.zero;

  return garage.add(carport);
};

export const selectGarageCarportCost = createPriceSelector(
  [selectGarageCost, selectCarportCost],
  calculateGarageCarportCost,
);

export const selectZipOnlyGarageCarportCost = createPriceSelector(
  [selectZipOnlyGarageCost, selectZipOnlyCarportCost],
  calculateGarageCarportCost,
);
